<template>
  <svg
    id="图层_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 310 300" style="enable-background:new 0 0 310 300;" xml:space="preserve"
  >
    <circle cx="160" cy="150" r="99" fill="currentColor" />
  </svg>
</template>
